// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"26":"6c277d84","160":"3c2ae5a6","379":"007e2011","555":"0e82f6b8","895":"be219695"}[chunkId] + ".js";
};